import { maxLength, minLength } from '@seek/validators-js';
import { Column, Columns, Dropdown, TextField } from 'braid-design-system';
import React from 'react';

import { Country, PopularCountries } from 'src/data/countries';
import { withoutHighlight } from 'src/utils';
import { numerical } from 'src/utils/validators';

import { useField } from '../../utils';

const PhoneNumberDetails = () => {
  const phonePrefix = withoutHighlight(
    useField({
      id: 'phoneCountryCode',
      validators: [],
    }),
  );

  const phoneNumber = withoutHighlight(
    useField({
      id: 'phoneNumber',
      validators: [numerical, minLength, maxLength],
      validatorProps: { min: 6, max: 10 },
    }),
  );
  return (
    <Columns space="small" collapseBelow="tablet">
      <Column width="2/5">
        <Dropdown
          id="prefixNumber"
          label="Country"
          onChange={phonePrefix.onChange}
          value={phonePrefix.value ?? '61'}
          placeholder="Australia"
        >
          <optgroup label="Common Countries">
            {PopularCountries.map(({ Id, Value, Name }) => (
              <option key={`${Id}`} value={`${Value}`}>
                {Name}
              </option>
            ))}
          </optgroup>
          <optgroup label="All Countries">
            {Country.map(({ Id, Value, Name }) => (
              <option key={`${Id}`} value={`${Value}`}>
                {Name}
              </option>
            ))}
          </optgroup>
        </Dropdown>
      </Column>
      <Column>
        <TextField
          id="phoneNumber"
          type="tel"
          prefix={phonePrefix.value ? `+${phonePrefix.value}` : '+61'}
          label="Phone number"
          onChange={phoneNumber.onChange}
          value={phoneNumber.value ? phoneNumber.value : ''}
          tone={phoneNumber.valid ? 'neutral' : 'critical'}
          message={!phoneNumber.valid && phoneNumber.errorMessage}
        />
      </Column>
    </Columns>
  );
};

export default PhoneNumberDetails;
